import { gql } from "apollo-boost";
import { Graph, QualifiedFeature } from "./shared";

export const AskKahunQueries = {
  PossibleConnections: gql`
    query ClinicalReasoningConnections(
      $search: [QualifiedFeatureInput]
      $depth: Int
      $limit: Int
    ) {
      clinicalReasoningConnections(
        search: $search
        depth: $depth
        limit: $limit
      ) {
        nodes {
          id
          finding {
            ...QualifiedFeature
          }
          score
          nodeType
        }
      }
    }
    ${QualifiedFeature}
  `,
  GetGraph: gql`
    query ClinicalReasoningConnectionGraph(
      $search: [QualifiedFeatureInput]
      $addition: [QualifiedFeatureInput]
      $depth: Int
      $limit: Int
    ) {
      clinicalReasoningConnections(
        search: $search
        depth: $depth
        limit: $limit
      ) {
        subgraph(nodes: $addition) {
          ...Graph
        }
      }
    }
    ${Graph}
  `,
};
